import React from 'react';
import { Box } from '@mui/material';
import {
    FaHome,
    FaTools,
    FaWater,
    FaUsers,
    FaMoneyBillWave,
    FaFileInvoiceDollar
} from 'react-icons/fa'; // Ícones atualizados
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../Common/ChartsContainer';
import InfrastructureWrapper from './Infrastructure';
import HouseholdWrapper from './Household';
import BasicSanitationWrapper from './BasicSanitation';
import TradicionalGroupsWrapper from './TraditionalGroups';
import HouseholdIncomeWrapper from './HouseholdIncome';
import HouseholdExpensesWrapper from './HouseholdExpenses';

const menus = [
    {
        title: 'Informações Domiciliares',
        path: '/governanceroom/dashboardunifiedregistry/families/household',
        icon: <FaHome style={{ marginRight: '5px' }} /> 
    },
    {
        title: 'Infraestrutura',
        path: '/governanceroom/dashboardunifiedregistry/families/infrastructure',
        icon: <FaTools style={{ marginRight: '5px' }} /> 
    },
    {
        title: 'Saneamento Básico',
        path: '/governanceroom/dashboardunifiedregistry/families/basic-sanitation',
        icon: <FaWater style={{ marginRight: '5px' }} /> 
    },
    {
        title: 'Grupos Tradicionais',
        path: '/governanceroom/dashboardunifiedregistry/families/traditional-groups',
        icon: <FaUsers style={{ marginRight: '5px' }} /> 
    },
    {
        title: 'Renda Domiciliar',
        path: '/governanceroom/dashboardunifiedregistry/families/income',
        icon: <FaMoneyBillWave style={{ marginRight: '5px' }} /> 
    },
    {
        title: 'Despesas Domiciliares',
        path: '/governanceroom/dashboardunifiedregistry/families/expenses',
        icon: <FaFileInvoiceDollar style={{ marginRight: '5px' }} /> 
    }
];

const titleMap = {
    '/governanceroom/dashboardunifiedregistry/families/household':
        'Informações Domiciliares',
    '/governanceroom/dashboardunifiedregistry/families/infrastructure':
        'Infraestrutura Domiciliar',
    '/governanceroom/dashboardunifiedregistry/families/basic-sanitation':
        'Saneamento Básico',
    '/governanceroom/dashboardunifiedregistry/families/traditional-groups':
        'Grupos Tradicionais',
    '/governanceroom/dashboardunifiedregistry/families/income':
        'Renda Domiciliar',
    '/governanceroom/dashboardunifiedregistry/families/expenses':
        'Despesas Domiciliares'
};

const Families = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardunifiedregistry');
    };

    return (
        <Box>
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="household" replace />}
                        />
                        <Route
                            path="household"
                            element={<HouseholdWrapper />}
                        />
                        <Route
                            path="infrastructure"
                            element={<InfrastructureWrapper />}
                        />
                        <Route
                            path="basic-sanitation"
                            element={<BasicSanitationWrapper />}
                        />
                        <Route
                            path="traditional-groups"
                            element={<TradicionalGroupsWrapper />}
                        />
                        <Route
                            path="income"
                            element={<HouseholdIncomeWrapper />}
                        />
                        <Route
                            path="expenses"
                            element={<HouseholdExpensesWrapper />}
                        />
                    </Routes>
                </ChartsContainer>
            </Box>
        </Box>
    );
};

export default Families;
